export default function Cross ({className}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class={`MuiSvgIcon-root ${className}`}>
      <g id="Checklist-cross" transform="translate(-0.729)">
        <circle id="Ellipse_705" data-name="Ellipse 705" cx="12" cy="12" r="12" transform="translate(0.729)" fill="#e68585"/>
        <path id="add_FILL0_wght400_GRAD0_opsz24" d="M206.625-751.167H201.1a1.068,1.068,0,0,1-.787-.317,1.068,1.068,0,0,1-.317-.787,1.068,1.068,0,0,1,.317-.787,1.068,1.068,0,0,1,.787-.318h5.521V-758.9a1.068,1.068,0,0,1,.317-.787,1.069,1.069,0,0,1,.787-.317,1.069,1.069,0,0,1,.787.317,1.068,1.068,0,0,1,.317.787v5.521h5.521a1.068,1.068,0,0,1,.787.318,1.068,1.068,0,0,1,.317.787,1.068,1.068,0,0,1-.317.787,1.068,1.068,0,0,1-.787.317h-5.521v5.521a1.068,1.068,0,0,1-.317.787,1.068,1.068,0,0,1-.787.317,1.068,1.068,0,0,1-.787-.317,1.068,1.068,0,0,1-.317-.787Z" transform="translate(-666.094 397.049) rotate(45)" fill="#fff"/>
      </g>
    </svg>
  )
}


